import * as XLSX from 'xlsx'

type XlsxRow = Record<string, string | number | null | undefined>

/** Gera e baixa um arquivo .xlsx com múltiplas abas a partir de linhas em formato de objeto (chaves = colunas). */
export function downloadXlsxMulti(
  sheets: Array<{ sheetName: string; rows: XlsxRow[] }>,
  fileName: string
): void {
  const workbook = XLSX.utils.book_new()
  for (const { sheetName, rows } of sheets) {
    const worksheet = XLSX.utils.json_to_sheet(rows)
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31))
  }
  XLSX.writeFile(workbook, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`)
}

/** Gera e baixa um arquivo .xlsx a partir de linhas em formato de objeto (chaves = colunas). */
export function downloadXlsx(sheetName: string, fileName: string, rows: XlsxRow[]): void {
  downloadXlsxMulti([{ sheetName, rows }], fileName)
}
